module.exports = __webpack_public_path__ + "static/media/shapes_11.ddb67047.svg";